export default __webpack_public_path__ + "static/engineering-a8d55598aba9617af0973318641dd354.svg";